/* global wolky_register_ajax */
export default {
  init() {
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    this.initializeRegistrationValidation();
  },
  finalize() {
  },

  initializeRegistrationValidation() {
    const form = $('.woocommerce-form-register');

    if (!form.length) {
      return;
    }

    const targetForm = form.first();

    const validationRules = {
      billing_first_name: {
        required: true,
        minLength: 1,
        validate: (value) => value.trim().length > 0,
      },
      billing_last_name: {
        required: true,
        minLength: 1,
        validate: (value) => value.trim().length > 0,
      },
      billing_phone: {
        required: false,
        validate: (value) => {
          if (!value) return true;
          return /^[+\d\s\-()]+$/.test(value);
        },
      },
      account_date_of_birth: {
        required: false,
        validate: (value) => {
          if (!value) return true;
          const formats = [
            /^\d{2}-\d{2}-\d{4}$/,
            /^\d{2}\/\d{2}\/\d{4}$/,
            /^\d{2}\.\d{2}\.\d{4}$/,
          ];
          return formats.some(format => format.test(value));
        },
      },
      billing_country: {
        required: true,
        validate: (value) => value && value.length === 2,
      },
      billing_postcode: {
        required: true,
        validate: (value) => value.trim().length > 0,
      },
      billing_house_number: {
        required: true,
        validate: (value) => {
          if (!value.trim()) return false;
          return /\d/.test(value);
        },
      },
      billing_street: {
        required: true,
        validate: (value) => value.trim().length > 0,
      },
      billing_city: {
        required: true,
        validate: (value) => value.trim().length > 0,
      },
      email: {
        required: true,
        validate: (value) => {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(value) && !value.includes('..');
        },
      },
      password: {
        required: true,
        minLength: 7,
        validate: (value) => value.length >= 7,
      },
    };

    const validateField = (fieldName, value) => {
      const rule = validationRules[fieldName];

      if (!rule) {
        return true;
      }

      if (rule.required && !value) {
        return false;
      }

      if (!rule.required && !value) {
        return true;
      }

      if (rule.validate) {
        return rule.validate(value);
      }

      return true;
    };

    const updateFieldState = (field, isValid) => {
      const fieldRow = field.closest('.form-row');
      const isRequired = validationRules[field.attr('name')]?.required;

      fieldRow.removeClass('woocommerce-validated woocommerce-invalid woocommerce-invalid-required-field');

      if (isValid) {
        if (field.val()) {
          fieldRow.addClass('woocommerce-validated');
          if (isRequired) {
            fieldRow.addClass('validate-required');
          }
        }
        fieldRow.find('.error-message').remove();

      } else {
        fieldRow.addClass('woocommerce-invalid');
        if (isRequired) {
          fieldRow.addClass('woocommerce-invalid-required-field');
        }
      }
    };

    targetForm.find('input[type="text"], input[type="email"], input[type="password"], input[type="tel"], select').each(function() {
      const field = $(this);
      const fieldName = field.attr('name');

      if (!validationRules[fieldName]) {
        return;
      }

      field.on('blur', function() {
        const value = field.val();
        const isValid = validateField(fieldName, value);
        updateFieldState(field, isValid);
      });

      field.on('change', function() {
        const value = field.val();
        const isValid = validateField(fieldName, value);
        updateFieldState(field, isValid);
      });

      let timeout;
      field.on('keyup', function() {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          const value = field.val();
          const isValid = validateField(fieldName, value);
          updateFieldState(field, isValid);
        }, 500);
      });
    });

    targetForm.off('submit').on('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      targetForm.find('.woocommerce-error, .woocommerce-message, .error-message').remove();
      targetForm.find('.woocommerce-invalid').removeClass('woocommerce-invalid woocommerce-invalid-required-field');

      const submitButton = targetForm.find('button[type="submit"]');
      const originalButtonText = submitButton.html();

      submitButton.prop('disabled', true);

      $.ajax({
        url: wolky_register_ajax.ajax_url,
        type: 'POST',
        data: targetForm.serialize() + '&nonce=' + wolky_register_ajax.nonce,
        success: function(response) {
          if (response.success) {
            targetForm.prepend('<div class="woocommerce-message" role="alert">' + response.data.message + '</div>');

            setTimeout(function() {
              window.location.href = response.data.redirect;
            }, 500);
          } else {
            targetForm.find('.error-message').remove();
            targetForm.find('.woocommerce-invalid').removeClass('woocommerce-invalid woocommerce-invalid-required-field');

            if (response.data.errors && typeof response.data.errors === 'object') {
              $.each(response.data.errors, function(fieldName, errorMessage) {
                const field = targetForm.find('[name="' + fieldName + '"]');
                if (field.length) {
                  const fieldRow = field.closest('.form-row');

                  fieldRow.addClass('woocommerce-invalid woocommerce-invalid-required-field');

                  fieldRow.find('.error-message').remove();

                  const inputWrapper = field.closest('.woocommerce-input-wrapper');
                  if (inputWrapper.length) {
                    inputWrapper.after('<span class="error-message">' + errorMessage + '</span>');
                  } else {
                    field.after('<span class="error-message">' + errorMessage + '</span>');
                  }
                }
              });

              const firstError = targetForm.find('.error-message').first();
              if (firstError.length) {
                $('html, body').animate({
                  scrollTop: firstError.closest('.form-row').offset().top - 100,
                }, 500);
              }
            }

            submitButton.prop('disabled', false).html(originalButtonText);
          }
        },
        error: function() {
          targetForm.prepend('<div class="woocommerce-error" role="alert">Registration failed. Please try again.</div>');

          submitButton.prop('disabled', false).html(originalButtonText);

          $('html, body').animate({
            scrollTop: targetForm.offset().top - 100,
          }, 500);
        },
      });

      return false;
    });
  },
};
